import { Component, DestroyRef, inject } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthandregistryService } from '../../../../../service/authandregistry.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-change-password',
    standalone: false,
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
    private destroyRef = inject(DestroyRef);

    newPassword: FormControl = new FormControl('');
    confirmPassword: FormControl = new FormControl('');
    oldPassword: FormControl = new FormControl('');
    samePasswords = false;

    constructor(private fb: FormBuilder, private dialogRef: MatDialogRef<ChangePasswordComponent>, private authandregService: AuthandregistryService) {
        this.newPassword.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: () => {
                    if (this.newPassword.value === this.confirmPassword.value) {
                        this.samePasswords = true;
                    } else {
                        this.samePasswords = false;
                    }
                },
            });

        this.confirmPassword.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: () => {
                    if (this.newPassword.value === this.confirmPassword.value) {
                        this.samePasswords = true;
                    } else {
                        this.samePasswords = false;
                        this.confirmPassword.setErrors({ notEqual: true });
                    }
                },
            });

        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter' && this.samePasswords && this.newPassword.valid) {
                        event.preventDefault();
                        this.changePw();
                    }
                },
            });
    }

    close() {
        this.dialogRef.close()
    }

    async changePw() {
        const result = await this.authandregService.changePassword(this.newPassword.value, this.oldPassword.value);

        if (result === true) {
            this.close();
        }
    }
}
